module.exports = __webpack_public_path__ + "img/m6.0baae0d6.png";